<template>
  <section id="admin-navbar">
    <div class>
      <el-row type="flex" align="middle">
        <el-col :md="4" :xs="10">
          <div class="logo">
            <router-link to="/">
              <img src="/img/nutron-logo.png" alt="nutron-logo" class="img-fluid" />
            </router-link>
          </div>
        </el-col>
        <el-col :md="16" class="hidden-sm-and-down">
          <ul class="menu-list">
            <li>
              <router-link to="/">home</router-link>
            </li>
            <li>
              <router-link :to="{name: 'store-locator'}">Store Locator</router-link>
            </li>
            <li>
              <router-link :to="{name: 'blog'}">Blog</router-link>
            </li>
            <li>
              <router-link :to="{name: 'contact'}">Contact Us</router-link>
            </li>
            <li>
              <router-link :to="{name: 'faqs'}">Faq</router-link>
            </li>
            <li>
              <router-link :to="{name: 'book-your-job'}">Book Your Job</router-link>
            </li>
          </ul>
        </el-col>
        <el-col :md="4">
          <ul class="card-icons-list">
            <li>
              <router-link to="/">
                <img src="/img/icons/zoom.svg" alt="icon" class="img-fluid" />
              </router-link>
            </li>
            <li>
              <router-link to="/">
                <img src="/img/icons/heart.svg" alt="icon" class="img-fluid" />
              </router-link>
            </li>
            <li>
              <router-link to="/">
                <img src="/img/icons/bag.svg" alt="icon" class="img-fluid" />
              </router-link>
            </li>
            <li>
              <el-dropdown>
                <el-button>
                  <img src="/img/icons/profile.png" alt="icon" class="img-fluid" />
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <li>
                    <router-link to="/update-profile">
                      <span>
                        <img src="/img/icons/profile.png" alt="icon" class="dropdown-icon" />
                      </span>Profile
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/whishlist">
                      <span>
                        <img src="/img/icons/whiselist.png" alt="icon" class="dropdown-icon" />
                      </span>My whishlist
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/my-orders">
                      <span>
                        <img src="/img/icons/shopping-bag.png" alt="icon" class="dropdown-icon" />
                      </span>Orders
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/">
                      <span>
                        <img src="/img/icons/logout.png" alt="icon" class="dropdown-icon" />
                      </span>Logout
                    </router-link>
                  </li>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <span class="nav-divider">
      <img src="/img/icons/nav_separater.png" alt class="img-fluid" />
    </span>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return { loading: false };
  },
  computed: {
    ...mapGetters("errors", ["getErrors", "getMessage"])
  },
  methods: {
    async logout() {
      this.loading = true;
      await this.$store.dispatch("auth/sign_out");
      this.loading = false;
      if (this.getMessage) {
        this.$message.success(this.getMessage);
        this.$store.dispatch("errors/clear");
        this.$router.push({ name: "home" });
      }
    }
  }
};
</script>

<style scoped lang="scss">
#admin-navbar {
  padding: 1.25em 2em;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  .menu-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    li:not(:last-child) {
      margin-right: 1.563em;
    }
    li {
      a {
        color: #000;
        text-transform: uppercase;
        font-size: 1em;
      }
    }
  }
  .card-icons-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    li {
      img {
        width: 1.063em;
      }
      a {
        color: #000;
        text-transform: uppercase;
        font-size: 0.875em;
        transition: all 0.5s ease-in-out;
        letter-spacing: 0.5px;
        &:hover {
          color: #11233f;
        }
      }
    }
    li:not(:last-child) {
      /*margin-right: 0.938em !important;*/
    }
    .el-button {
      border: none;
      &:hover {
        background: transparent;
      }
    }
  }
}
</style>
